import { valueTypeMap } from '@pkg/ui/proValueTypes'
import { activeRangeValueType } from './activeRangeValueType'

export const appValueTypeMap = { ...valueTypeMap, activeRange: activeRangeValueType }

import type { SimpleRelationValidPeriod } from '@app/icare/entities/patient/schema/PatientRelation'

declare module '@pkg/ui/proValueTypes/types' {
  interface CustomValueTypeMap {
    activeRange: SimpleRelationValidPeriod | null | undefined
  }
}
